import { render, staticRenderFns } from "./integralExchangeRecordAdd.vue?vue&type=template&id=38354eac&scoped=true&"
import script from "./integralExchangeRecordAdd.vue?vue&type=script&lang=js&"
export * from "./integralExchangeRecordAdd.vue?vue&type=script&lang=js&"
import style0 from "./integralExchangeRecordAdd.vue?vue&type=style&index=0&id=38354eac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38354eac",
  null
  
)

export default component.exports